import React, { Component } from 'react';
import { Button, Table, Form, Input, Divider, message, Rate, Select } from 'antd';
import axios from '../../service/index'
import './auditManagement.less'
const { Option } = Select;
class AuditManagement extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectValue: undefined,
			subjectValue: undefined,
			visible: false,
			lableListData: [],
			total: 0,
			name: '',
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			labelName: '',
			labelId: null,
			ids: '',
			optionList: [],
			columns: [
				{
					title: '评论内容',
					width: '180px',
					dataIndex: 'content',
					key: 'content',
					align: 'center',
					render: (record, text) => {
						return <div>
							{record}
							<br />
							<Rate disabled allowHalf defaultValue={Number(text.star)} />
						</div>
					}
				},
				{
					title: '课程名称',
					dataIndex: 'courseName',
					key: 'courseName',
					align: 'center'
				},
				{
					title: '所属学科',
					dataIndex: 'subjectName',
					key: 'subjectName',
					align: 'center'
				},
				{
					title: '评论人',
					dataIndex: 'userName',
					key: 'userName',
					align: 'center'
				},
				{
					title: '手机号',
					dataIndex: 'phone',
					key: 'phone',
					align: 'center'
				},
				{
					title: '审核状态',
					dataIndex: 'status',
					key: 'status',
					align: 'center',
					render: (record) => {
						if (record === 0) {
							return '待审核'
						}
						if (record === 1) {
							return '审核通过'
						}
						if (record === 2) {
							return '屏蔽'
						}
					}
				},
				{
					title: '评论时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						{record.status !== 0 ? '' : <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							axios.post('commentController/publish', {
								id: record.id
							}).then(res => {
								if (res.data.code === '200') {
									message.success('审核通过')
									this.lableList()
								} else {
									message.error(res.data.msg)
								}
							})

						}}>通过</span>}
						{record.status !== 0 ? '' : <span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							axios.post('commentController/cancel', {
								id: record.id
							}).then(res => {
								if (res.data.code === '200') {
									message.success('屏蔽成功')
									this.lableList()
								} else {
									message.error(res.data.msg)
								}
							})
						}}>屏蔽</span>}
					</div>
				},
			]
		}
	}
	componentDidMount() {
		this.lableList()
		this.getOption()
	}
	showModal = (e) => {
		this.setState({
			modelTitle: '新增标签',
			visible: true
		})

	}

	lableList = () => {
		axios.post('commentController/getList', {
			...this.state.searchData,
			courseName: this.state.name,
			subjectId: this.state.subjectValue,
			status: +this.state.selectValue,

		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					lableListData: res.data.data.list,
					total: res.data.data.total
				})

			}
		})
	}
	delLable(id) {
		axios.get(`labelController/del/${id}`).then(res => {
			if (res.data.code === '200') {
				message.success('删除成功')
				this.lableList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false
		})
	};
	batchPass() {
		axios.post('commentController/batch/publish', {
			ids: this.state.ids
		}).then(res => {
			if (res.data.code === '200') {
				message.success('批量操作通过成功')
				this.lableList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	batchReject() {
		axios.post('commentController/batch/cancel', {
			ids: this.state.ids
		}).then(res => {
			if (res.data.code === '200') {
				message.success('批量操作屏蔽成功')
				this.lableList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	getOption() {
		axios.get('subjectController/getOption').then( res => {
			if(res.data.code === '200'){
				let arr = res.data.data
				this.setState({
					optionList: arr
				})
			}
		})
	}
	render() {
		const { lableListData, columns, total, show } = this.state
		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.lableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.lableList(searchData)
			},
		}
		const rowSelection = {
			onChange: (selectedRowKeys, selectedRows) => {
				this.setState({
					ids: selectedRowKeys
				})
			},
			onSelect: (record, selected, selectedRows) => {
				this.setState({
					show: selected
				})
			},
			onSelectAll: (selected, selectedRows, changeRows) => {
				this.setState({
					show: selected
				})
			},
		};
		return (
			<div>
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>审核管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px',alignItems: 'center' }}>
					<div>
						<Input allowClear value={this.state.name} style={{ width: '250px', height: '40px', marginRight: '20px' }}
							placeholder="请输入课程名称"
							onChange={(e) => {
								this.setState({
										name: e.target.value
								})
							}}
						></Input>
						<Select  placeholder="审核状态" value={this.state.selectValue} allowClear style={{ width: 140, height: '40px', marginRight: '20px' }} onChange={(value)=>{
							this.setState({
								selectValue: value
							})
						}}>
							<Option value="0">待审核</Option>
							<Option value="1">通过</Option>
							<Option value="2">屏蔽</Option>
						</Select>
						<Select  placeholder="选择学科" value={this.state.subjectValue} allowClear style={{ width: 140, height: '40px', marginRight: '20px' }} onChange={(value)=>{
							this.setState({
								subjectValue: value
							})
						}}>
							{this.state.optionList.map(item=>{
								return (<Option key={item.id+item.name} value={item.id}>{item.name}</Option>)
							})}
						</Select>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.lableList()
						}}>搜索</Button>
						<span className="my-button-txt" style={{marginLeft: '20px'}} onClick={() => {
							this.setState({
								selectValue: undefined,
								name: '',
								subjectValue: undefined
							},()=>{
								this.lableList()
							})
						}}>重置</span>
					</div>
					{show && <div>
						<span className="my-button-txt" onClick={() => {
							this.batchPass()
						}}>批量通过</span>
						<span className="my-button-danger" style={{ marginLeft: '20px' }} onClick={() => {
							this.batchReject()
						}}>批量屏蔽</span>
					</div>}
				</div>
				<Table rowSelection={rowSelection} dataSource={lableListData} columns={columns} rowKey={record => record.id} pagination={pagination} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}/>

			</div>
		)
	}

};

export default Form.create()(AuditManagement)
